"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../helpers/time");
var sortBy_1 = __importDefault(require("lodash/sortBy"));
var time_2 = require("../helpers/time");
var CalendarService = /** @class */ (function () {
    function CalendarService(DrivesFilterService, CalendarModel, $state, $rootScope, UserService, $timeout, VueStoreFactory) {
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.UserService = UserService;
        this.VueStoreFactory = VueStoreFactory;
        this.DrivesFilterService = DrivesFilterService;
        this.CalendarModel = CalendarModel;
        this.$timeout = $timeout;
        /**
         * The collection to be sent to the calendar
         */
        this.calendar = [];
        /**
         * The collection to be sent to the agenda
         */
        this.agenda = [];
        this.getCalendarItems = this.getCalendarItems.bind(this);
        this.setCalendarItems = this.setCalendarItems.bind(this);
        this.getAgendaItems = this.getAgendaItems.bind(this);
        this.setAgendaItems = this.setAgendaItems.bind(this);
        this.setCalendarView = this.setCalendarView.bind(this);
        this.getCalendarView = this.getCalendarView.bind(this);
        this.clearItems = this.clearItems.bind(this);
        this.processCalendar = this.processCalendar.bind(this);
        this.processAgenda = this.processAgenda.bind(this);
        this.handleEventClick = this.handleEventClick.bind(this);
        this.handleDateClick = this.handleDateClick.bind(this);
        this.handleCalDestroy = this.handleCalDestroy.bind(this);
        this.getCalendarEvents = this.getCalendarEvents.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.disableFullCalendarControls =
            this.disableFullCalendarControls.bind(this);
        this.enableFullCalendarControls =
            this.enableFullCalendarControls.bind(this);
    }
    /**
     * Get the calendar items
     */
    CalendarService.prototype.getCalendarItems = function () {
        return this.calendar;
    };
    /**
     * Set the calendar items
     * @param data CalendarItem[]
     */
    CalendarService.prototype.setCalendarItems = function (data) {
        this.calendar = data;
    };
    /**
     * Get the agenda items
     * @returns {Array|*}
     */
    CalendarService.prototype.getAgendaItems = function () {
        return this.agenda;
    };
    /**
     * Set the agenda items
     * @param data
     */
    CalendarService.prototype.setAgendaItems = function (data) {
        this.agenda = data;
    };
    CalendarService.prototype.clearItems = function () {
        this.calendar = [];
        this.agenda = [];
    };
    /**
     * Set/get the calendar view (month/week/day)
     * @param viewType
     */
    CalendarService.prototype.setCalendarView = function (viewType) {
        this.calendarView = viewType;
    };
    CalendarService.prototype.getCalendarView = function () {
        return this.calendarView;
    };
    CalendarService.prototype.processAgenda = function (response) {
        var _this = this;
        var _allItems = [];
        if (typeof response.data.drives !== "undefined") {
            response.data.drives
                .map(function (drive) {
                // Transform API response to processed item - use any for intermediate mutation
                var processed = drive;
                processed.date = drive.drive_date;
                processed.startTime = (0, time_1.formatTimeString)(drive.start_time);
                processed.typeDisplay =
                    typeof drive.type === "string" ? drive.type : drive.type.name;
                processed.type = "Drive Session";
                if (drive.private === "Y" && drive.observation === false) {
                    processed.typeDisplay = processed.typeDisplay + " (Hidden)";
                }
                processed.timestamp = (0, time_1.getUnixTimestamp)((0, time_2.dateTimeStringToDate)(drive.drive_date + " " + drive.start_time));
                if (drive.location) {
                    processed.location = drive.location;
                }
                var datetime = (0, time_2.dateTimeStringToDate)(processed.date + " " + drive.start_time);
                var endTimeDate = (0, time_1.addMinutes)((0, time_2.timeStringToDate)(drive.start_time), drive.session_length);
                processed.endTime = (0, time_1.formatDateTime)(endTimeDate, "h:mm A");
                processed.duration = (0, time_1.formatDuration)(drive.session_length);
                processed.styling =
                    _this.CalendarModel.getStylingForDriveCard(processed);
                processed.actionRequired =
                    drive.hasUngradedReportcards === true &&
                        drive.status === "Taken" &&
                        (0, time_1.isBefore)(datetime, new Date());
                return processed;
            })
                .forEach(function (drive) {
                _allItems.push(drive);
            });
        }
        if (typeof response.data.courses !== "undefined") {
            response.data.courses
                .map(function (course) {
                // Transform API response to processed item
                var processed = course;
                var originalDuration = course.duration;
                processed.type = "Course";
                processed.styling = "course";
                processed.typeDisplay = course.course_type_name + ": " + course.name;
                processed.location = course.location;
                processed.timestamp = (0, time_1.getUnixTimestamp)((0, time_2.dateTimeStringToDate)(course.date + " " + course.time));
                processed.duration = (0, time_1.formatDuration)(originalDuration);
                if (course.classes && course.classes.length > 0) {
                    processed.classes = course.classes.map(function (classDate) {
                        var classDateWithCourseInfo = {
                            //refine course info
                            date: (0, time_1.formatDateTime)((0, time_2.dateTimeStringToDate)(classDate.start), "YYYY-MM-DD"),
                            startTime: (0, time_1.formatDateTime)((0, time_2.dateTimeStringToDate)(classDate.start), "h:mm A"),
                            endTime: (0, time_1.formatDateTime)((0, time_2.dateTimeStringToDate)(classDate.end), "h:mm A"),
                            class_id: classDate.id,
                            instructor: classDate.instructor,
                            location: processed.location,
                            classroom: course.classroom,
                            id: course.id,
                            name: course.name,
                            type: processed.type,
                            course_type_name: course.course_type_name,
                            typeDisplay: processed.typeDisplay,
                            timestamp: (0, time_1.getUnixTimestamp)((0, time_2.dateTimeStringToDate)(classDate.start)),
                            label: course.label,
                            styling: processed.styling,
                        };
                        return classDateWithCourseInfo;
                    });
                }
                else {
                    var endTimeDate = (0, time_1.addMinutes)((0, time_2.timeStringToDate)(course.time), originalDuration);
                    processed.end_time = (0, time_1.formatDateTime)(endTimeDate, "HH:mm:ss");
                    processed.endTime = (0, time_1.formatDateTime)(endTimeDate, "h:mm A");
                    processed.startTime = (0, time_1.formatTimeString)(course.time);
                }
                return processed;
            })
                .forEach(function (course) {
                if (course.classes && course.classes.length > 0) {
                    _allItems.push.apply(_allItems, course.classes);
                }
                else {
                    _allItems.push(course);
                }
            });
        }
        if (typeof response.data.events !== "undefined") {
            response.data.events
                .map(function (event) {
                // Transform API response to processed item
                var processed = event;
                var originalDuration = typeof event.duration === "string"
                    ? parseInt(event.duration, 10)
                    : event.duration;
                processed.typeDisplay = "Event: " + event.name;
                processed.styling = "event";
                processed.type = "Event";
                processed.location = event.location;
                processed.timestamp = (0, time_1.getUnixTimestamp)((0, time_2.dateTimeStringToDate)(event.date.split(" ")[0] + " " + event.time));
                var endTimeDate = (0, time_1.addMinutes)((0, time_2.timeStringToDate)(event.time), originalDuration);
                processed.endTime = (0, time_1.formatDateTime)(endTimeDate, "h:mm A");
                processed.startTime = (0, time_1.formatTimeString)(event.time);
                processed.duration = (0, time_1.formatDuration)(originalDuration);
                return processed;
            })
                .forEach(function (event) {
                _allItems.push(event);
            });
        }
        if (typeof response.data.timeoffrequests !== "undefined") {
            response.data.timeoffrequests
                .map(function (rto) {
                // Transform API response to processed item
                var processed = rto;
                processed.typeDisplay = "RTO";
                if (!processed.rto_type) {
                    processed.rto_type = rto.type;
                    processed.type = "RTO";
                }
                var _start_ = (0, time_2.dateTimeStringToDate)(rto.begin);
                var _end_ = (0, time_2.dateTimeStringToDate)(rto.end);
                processed.timestamp = (0, time_1.getUnixTimestamp)(_start_);
                // Dont show times for full or range type RTO
                if (processed.rto_type === "full" || processed.rto_type === "range") {
                    var s_moment = (0, time_1.endOfDay)((0, time_2.dateStringToDate)(_this.DrivesFilterService.getDate()));
                    var e_moment = (0, time_1.startOfDay)((0, time_2.dateStringToDate)(_this.DrivesFilterService.getDate()));
                    processed.endTime = (0, time_1.formatDateTime)(s_moment, "h:mm A");
                    processed.startTime = (0, time_1.formatDateTime)(e_moment, "h:mm A");
                    processed.duration = (0, time_1.formatDuration)((0, time_1.differenceInMinutes)(s_moment, e_moment));
                }
                else {
                    processed.endTime = (0, time_1.formatDateTime)((0, time_2.dateTimeStringToDate)(rto.end), "h:mm A");
                    processed.startTime = (0, time_1.formatDateTime)((0, time_2.dateTimeStringToDate)(rto.begin), "h:mm A");
                    processed.duration = (0, time_1.formatDuration)((0, time_1.differenceInMinutes)(_end_, _start_));
                }
                return processed;
            })
                .forEach(function (rto) {
                _allItems.push(rto);
            });
        }
        return (0, sortBy_1.default)(_allItems, function (item) {
            return item.timestamp;
        });
    };
    CalendarService.prototype.processCalendar = function (response) {
        var _allItems = [];
        if (typeof response.data.drives !== "undefined") {
            response.data.drives
                .map(function (drive) {
                drive.date = (0, time_1.toYMD)((0, time_2.dateStringToDate)(drive.drive_date));
                drive.startTime = (0, time_1.formatDateTime)((0, time_2.timeStringToDate)(drive.start_time), "HH:mm:ss");
                drive.timestamp = (0, time_1.getUnixTimestamp)((0, time_2.dateTimeStringToDate)(drive.drive_date + " " + drive.start_time));
                //calendarDisplay used in vue cal
                drive.calendarDisplay = drive.label.type;
                drive.typeDisplay = drive.label.type;
                drive.type = "Drive Session";
                if (drive.private === "Y") {
                    drive.typeDisplay += " (Hidden)";
                    drive.calendarDisplay += " (Hidden)";
                }
                if (drive.student_id !== 0) {
                    drive.calendarDisplay = "".concat(drive.student_name, " - ").concat(drive.typeDisplay);
                }
                //agendaDisplay used in miniCalendarAgenda.vue (agenda on side of main cal)
                drive.agendaDisplay = drive.calendarDisplay;
                if (drive.calendarDisplay === "Drive") {
                    drive.calendarDisplay = "Open Session";
                }
                var sessionMinutes = typeof drive.session_length === "string"
                    ? parseInt(drive.session_length, 10)
                    : drive.session_length;
                var endTimeDate = (0, time_1.addMinutes)((0, time_2.dateTimeStringToDate)(drive.date + " " + drive.start_time), sessionMinutes);
                drive.endTime = (0, time_1.formatDateTime)(endTimeDate, "h:mm A");
                //end_time format is different, needs to be 24hr time for safari/firefox bug
                drive.end_time = (0, time_1.formatDateTime)(endTimeDate, "HH:mm:ss");
                drive.duration = (0, time_1.formatDuration)(sessionMinutes);
                //start and end are for vue full calendar
                drive.start = (0, time_2.dateTimeStringToDate)(drive.date + " " + drive.start_time);
                drive.end = new Date(endTimeDate);
                return drive; //return drive.status === 'Taken';
            })
                .forEach(function (drive) {
                _allItems.push(drive);
            });
        }
        if (typeof response.data.courses !== "undefined") {
            response.data.courses
                .map(function (course) {
                course.type = "Course";
                course.typeDisplay = course.name;
                course.calendarDisplay = course.name;
                if (course.private === "Y") {
                    course.calendarDisplay += " (Hidden)";
                }
                course.agendaDisplay = course.calendarDisplay;
                course.date = (0, time_1.toYMD)((0, time_2.dateStringToDate)(course.date));
                course.timestamp = (0, time_1.getUnixTimestamp)((0, time_2.dateTimeStringToDate)(course.date + " " + course.time));
                if (course.classes && course.classes.length > 0) {
                    course.classes = course.classes.map(function (classDate) {
                        var classDateWithCourseInfo = {
                            //refine course info
                            date: (0, time_1.toYMD)((0, time_2.dateTimeStringToDate)(classDate.start)),
                            start: (0, time_2.dateTimeStringToDate)(classDate.start),
                            end: (0, time_2.dateTimeStringToDate)(classDate.end),
                            class_id: classDate.id,
                            instructor_id: classDate.instructor.id,
                            instructor_name: classDate.instructor.name,
                            location_name: course.location_name,
                            classroom_name: course.classroom_name,
                            id: course.id,
                            label: course.label,
                            name: course.name,
                            type: course.type,
                            course_type_name: course.course_type_name,
                            duration: course.duration,
                            calendarDisplay: course.calendarDisplay,
                            timestamp: (0, time_1.getUnixTimestamp)(classDate.start),
                            agendaDisplay: course.agendaDisplay,
                        };
                        return classDateWithCourseInfo;
                    }); // Type assertion needed as we're transforming the structure
                }
                else {
                    course.startTime = (0, time_1.formatTimeString)(course.time);
                    var endTimeDate = (0, time_1.addMinutes)((0, time_2.timeStringToDate)(course.time), parseInt(course.duration, 10));
                    course.endTime = (0, time_1.formatDateTime)(endTimeDate, "h:mm A");
                    course.end_time = (0, time_1.formatDateTime)(endTimeDate, "HH:mm:ss");
                    //start and end are for vue full calendar
                    course.start = (0, time_2.dateTimeStringToDate)(course.date + " " + course.time);
                    course.end = (0, time_2.dateTimeStringToDate)(course.date + " " + course.end_time);
                }
                course.duration = (0, time_1.formatDuration)(parseInt(course.duration, 10));
                return course;
            })
                .forEach(function (course) {
                if (course.classes && course.classes.length > 0) {
                    _allItems.push.apply(_allItems, course.classes);
                }
                else {
                    _allItems.push(course);
                }
            });
        }
        if (typeof response.data.events !== "undefined") {
            response.data.events
                .map(function (event) {
                var date = event.calDate.split("/");
                event.date = (0, time_1.toYMD)(new Date(parseInt(date[2], 10), parseInt(date[0], 10) - 1, parseInt(date[1], 10), 0, 0, 0));
                var eventdatetime = event.date + " " + event.time;
                event.typeDisplay = "Event";
                event.calendarDisplay = event.name;
                if (event.private === "Y") {
                    event.calendarDisplay += " (Hidden)";
                }
                event.type = "Event";
                event.agendaDisplay = event.calendarDisplay;
                // event.location = angular.fromJson( event.location );
                event.timestamp = (0, time_1.getUnixTimestamp)((0, time_2.dateTimeStringToDate)(event.date + " " + event.time));
                var endTimeDate = (0, time_1.addMinutes)((0, time_2.timeStringToDate)(event.time), parseInt(event.duration, 10));
                event.endTime = (0, time_1.formatDateTime)(endTimeDate, "h:mm A");
                event.end_time = (0, time_1.formatDateTime)(endTimeDate, "HH:mm:ss");
                event.startTime = (0, time_1.formatTimeString)(event.time);
                event.duration = (0, time_1.formatDuration)(parseInt(event.duration, 10));
                //start and end are for vue full calendar
                event.start = (0, time_2.dateTimeStringToDate)(eventdatetime);
                event.end = (0, time_2.dateTimeStringToDate)(event.date + " " + event.end_time);
                return event;
            })
                .forEach(function (event) {
                _allItems.push(event);
            });
        }
        if (typeof response.data.timeoffrequests !== "undefined") {
            response.data.timeoffrequests.forEach(function (rto) {
                if (!rto.rto_type) {
                    rto.rto_type = rto.type;
                }
                rto.type = "RTO";
                rto.calendarDisplay = rto.type + " " + rto.instructor_name;
                rto.agendaDisplay = rto.calendarDisplay;
                var _start_ = (0, time_2.dateTimeStringToDate)(rto.begin);
                var _end_ = (0, time_2.dateTimeStringToDate)(rto.end);
                rto.timestamp = (0, time_1.getUnixTimestamp)(_start_);
                _allItems.push(rto);
            });
        }
        return _allItems;
    };
    CalendarService.prototype.goToAgenda = function (data) {
        var dateStr = data.dateStr, context = data.context;
        if (typeof context !== "undefined") {
            switch (context) {
                case "student":
                    this.$state.go("drivecoach.student.drives.agenda", { date: dateStr });
                    break;
                case "admin":
                    this.$state.go("drivecoach.admin.agenda", { date: dateStr });
                    break;
                case "instructor":
                    this.$state.go("drivecoach.instructor.dashboard.agenda", {
                        date: dateStr,
                    });
                    break;
                case "instructor_team_calendar":
                    this.$state.go("drivecoach.instructor.dashboard.teamagenda", {
                        date: dateStr,
                    });
                    break;
                default:
                    break;
            }
        }
    };
    CalendarService.prototype.openAdminRTOModal = function (data) {
        this.$rootScope.$broadcast("OPEN_RTO_MODAL", data);
    };
    CalendarService.prototype.handleAdminEventClick = function (data) {
        switch (data.eventName) {
            case "SESSION":
                this.$state.go("drivecoach.admin.drives.edit", { id: data.id });
                break;
            case "OPEN SESSION":
                this.$state.go("drivecoach.admin.drives.edit", { id: data.id });
                break;
            case "COURSE":
                this.VueStoreFactory.dispatch("SET_VIEW_COURSE", {
                    id: data.id,
                    class_id: data.event.extendedProps.class_id,
                    date: (0, time_2.dateTimeStringToDate)(data.dateStr + " " + data.event.extendedProps.eventStart).toLocaleDateString(),
                    start: (0, time_2.dateTimeStringToDate)(data.dateStr + " " + data.event.extendedProps.eventStart).toLocaleTimeString("en-US", { hour: "numeric", minute: "numeric" }),
                    end: (0, time_2.dateTimeStringToDate)(data.dateStr + " " + data.event.extendedProps.eventEnd).toLocaleTimeString("en-US", { hour: "numeric", minute: "numeric" }),
                });
                this.$state.go("drivecoach.admin.courses.view", {
                    courseId: data.id,
                });
                break;
            case "EVENT":
                this.$state.go("drivecoach.admin.events.edit", {
                    eventId: data.id,
                });
                break;
            case "RTO":
                this.openAdminRTOModal(data);
                break;
            default:
                break;
        }
    };
    CalendarService.prototype.handleInstructorEventClick = function (data) {
        this.goToAgenda(data);
    };
    CalendarService.prototype.handleEventClick = function (data) {
        //data is object with 'context', 'id', eventName, event, and date
        var id = data.id, context = data.context, eventName = data.eventName, event = data.event, date = data.date;
        if (typeof context !== "undefined") {
            switch (context) {
                case "admin":
                    this.handleAdminEventClick(data);
                    break;
                case "instructor":
                    this.handleInstructorEventClick(data);
                    break;
                case "instructor_team_calendar":
                    this.handleInstructorEventClick(data);
                    break;
                default:
                    break;
            }
        }
    };
    CalendarService.prototype.handleDateClick = function (data) {
        this.goToAgenda(data);
    };
    CalendarService.prototype.getFilterQuery = function (data) {
        var start_date = data.start_date, end_date = data.end_date, context = data.context;
        var query = structuredClone(this.DrivesFilterService.getFilterParameters());
        query.start_date = (0, time_1.formatDateTime)(start_date, "YYYY-MM-DD");
        query.end_date = (0, time_1.formatDateTime)(end_date, "YYYY-MM-DD");
        delete query.date;
        this.DrivesFilterService.setStartDate(new Date(start_date).valueOf());
        this.DrivesFilterService.setEndDate(new Date(end_date).valueOf());
        if (context === "instructor") {
            query.instructor = this.UserService.getCurrentUser();
        }
        query.statusIsnt = "Inactive - Scheduling Conflict";
        return query;
    };
    CalendarService.prototype.getDrivesMethod = function (filterQuery, context) {
        switch (context) {
            case "instructor":
                return this.CalendarModel.getInstructorCalendar(filterQuery);
                break;
            case "instructor_team_calendar":
                return this.CalendarModel.filterAdminCalendar(filterQuery);
                break;
            case "student":
                return this.CalendarModel.getStudentCalendar(filterQuery);
                break;
            case "admin":
                return this.CalendarModel.filterAdminCalendar(filterQuery);
                break;
        }
    };
    CalendarService.prototype.disableFullCalendarControls = function () {
        var buttons = document.getElementsByClassName("fc-button");
        for (var i = 0; i < buttons.length; i++) {
            var button = buttons[i];
            button.setAttribute("disabled", "true");
        }
    };
    CalendarService.prototype.enableFullCalendarControls = function () {
        var buttons = document.getElementsByClassName("fc-button");
        this.$timeout(function () {
            for (var i = 0; i < buttons.length; i++) {
                var button = buttons[i];
                button.removeAttribute("disabled");
            }
        }, 500);
    };
    CalendarService.prototype.setCalendarViewData = function (data) {
        this.DrivesFilterService.setStartDate(data.startDate);
        this.DrivesFilterService.setEndDate(data.endDate);
        this.setCalendarView(data.viewType);
    };
    CalendarService.prototype.getCalendarEvents = function (data) {
        var _this = this;
        this.$rootScope.$broadcast("CALENDAR_LOADING");
        this.disableFullCalendarControls();
        var queryData = {
            start_date: data.startDate,
            end_date: data.endDate,
            context: data.context,
        };
        var filterQuery = this.getFilterQuery(queryData);
        var getDrives = this.getDrivesMethod(filterQuery, data.context);
        return getDrives.then(function (response) {
            // DrivesFilterService.setAgenda(response);
            var formattedResponse = _this.processCalendar(response);
            // formattedResponse is already an array of calendar items, no need to filter
            _this.setCalendarItems(formattedResponse);
            _this.$rootScope.$broadcast("UPDATE_CALENDAR");
            // re-enable the prev and next buttons
            _this.enableFullCalendarControls();
            return formattedResponse;
        });
    };
    CalendarService.prototype.handleDateChange = function (data) {
        this.setCalendarViewData(data);
        this.getCalendarEvents(data);
    };
    CalendarService.prototype.handleCalDestroy = function (data) {
        //used to reload drives/events for proper dates when calendar page is reloaded
        this.setCalendarViewData(data);
    };
    return CalendarService;
}());
CalendarService.$inject = [
    "DrivesFilterService",
    "CalendarModel",
    "$state",
    "$rootScope",
    "UserService",
    "$timeout",
    "VueStoreFactory",
];
exports.default = CalendarService;
